import type { Faro } from "@grafana/faro-web-sdk";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  let faro: Faro | undefined;

  // Stub exposed right away; forwards to the real Faro once it is loaded.
  const stub = {
    api: {
      startUserAction: (...args: Parameters<Faro["api"]["startUserAction"]>) => faro?.api.startUserAction(...args),
    },
  };

  if (config.public.grafanaFaroUrl) {
    const load = async () => {
      try {
        const { ErrorsInstrumentation, initializeFaro, SessionInstrumentation, WebVitalsInstrumentation } = await import("@grafana/faro-web-sdk");
        faro = initializeFaro({
          url: config.public.grafanaFaroUrl,
          // Errors and web vitals only, to keep Faro off the main thread on first load.
          // Session stays: it sets the session id and the sampling that Grafana groups data by.
          instrumentations: [
            new ErrorsInstrumentation(),
            new WebVitalsInstrumentation(),
            new SessionInstrumentation(),
          ],
          app: {
            name: config.public.grafanaAppName,
            version: config.public.appVersion,
            environment: config.public.appEnvironment,
          },
        });
      }
      catch (error) {
        console.error("Failed to initialize Faro:", error);
      }
    };

    // Wait for the app to be mounted, then for an idle moment.
    nuxtApp.hook("app:mounted", () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(() => void load(), { timeout: 5000 });
      }
      else {
        setTimeout(() => void load(), 1);
      }
    });
  }

  return { provide: { faro: stub } };
});
